<template>
  <nav class="breadcrumbs">
    <span v-for="(breadcrumb, index) in breadcrumbs" :key="index">
      <nuxt-link v-if="breadcrumb.to" :to="breadcrumb.to">{{
        breadcrumb.text
      }}</nuxt-link>
      <span v-else>{{ breadcrumb.text }}</span>
    </span>
  </nav>
</template>

<script>
export default {
  name: 'BreadcrumbComponent',
  props: {
    breadcrumbs: {
      type: Array,
      required: true,
    },
  },
}
</script>
